var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPointCoins = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7A328",
  d: "M11 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7A328",
  d: "M11 4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 7.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM5.56 9.785A5.14 5.14 0 0 1 5.5 9c0-.296.024-.592.07-.885-.37.035-.73.05-1.07.05a10.06 10.06 0 0 1-4-.755v1.5c.315.35 1.895.91 4 .91.354.007.708-.005 1.06-.035Zm-1.06 1.05a10.06 10.06 0 0 1-4-.755V12c0 1.46 3.59 1.5 4 1.5a10.15 10.15 0 0 0 2.85-.39 5.5 5.5 0 0 1-1.56-2.35c-.428.049-.859.074-1.29.075Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7A328",
  d: "M5.845 7.085A5.5 5.5 0 0 1 8.5 4.1V4c0-1.46-3.59-1.5-4-1.5-.41 0-4 .04-4 1.5v2.255c.315.35 1.895.91 4 .91.45 0 .899-.026 1.345-.08Z"
})));
export default SvgPointCoins;